(function(){
'use strict';

scDigitalWalletsService.$inject = ["scStripeService", "scAnalytics", "scFeeOnTopService", "$q"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind service
 * @name scDigitalWalletsService
 *
 * @description
 * Handles Stripe tings
 */

function scDigitalWalletsService(scStripeService, scAnalytics, scFeeOnTopService, $q) {
  var _this = this;

  this.showDigitalWalletsListeners = [];
  this.onDigitalWalletsSubmitListeners = [];
  this.onOpenDigitalWalletModalListeners = [];
  this.isDigitalWalletSubmission = false;
  this.isLoaded = false;
  this.stripePublicKey = false;
  this.requestCanceller = null;

  this.paymentRequestParams = {
    country: 'US',
    amount: 0 // stripe will throw an error if this is undefined on initial create (will be updated anyways)
  };

  this.initDigitalWallets = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isLoaded) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return _this.updatePaymentRequestParams(params);

            case 4:
              _context.next = 6;
              return scStripeService.init(params.currency);

            case 6:
              scStripeService.createPaymentRequest(_this.paymentRequestParams, params.submit);

              _context.next = 9;
              return scStripeService.canMakePayment();

            case 9:
              result = _context.sent;

              if (result) {
                scAnalytics.track('dw_loaded', { digitalWalletsLoaded: true });
                _this.isApplePay = result.applePay;
                _this.showDigitalWallets(true);
              } else {
                scAnalytics.track('dw_loaded', { digitalWalletsLoaded: false });
                _this.showDigitalWallets(false);
              }
              _this.setIsLoaded(true);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.updatePaymentRequest = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.updatePaymentRequestParams(params);

            case 2:
              scStripeService.updatePaymentRequest(_this.paymentRequestParams);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.updatePaymentRequestParams = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
      var currentCanceller, response, frequency;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // Cancel the previous api request
              if (_this.requestCanceller) {
                _this.requestCanceller.resolve('cancelled');
              }

              currentCanceller = $q.defer();

              _this.requestCanceller = currentCanceller;

              if (!params.classyMode) {
                _context3.next = 7;
                break;
              }

              _this.paymentRequestParams.amount = params.amount;
              _context3.next = 18;
              break;

            case 7:
              if (!(params.amount > 0)) {
                _context3.next = 18;
                break;
              }

              _context3.prev = 8;
              _context3.next = 11;
              return scFeeOnTopService.transactionEstimate(params.amount, {
                processor_name: 'STRIPE',
                payment_method: 'DW',
                currency: params.currency,
                fot: params.fot
              }, {
                timeout: currentCanceller.promise
              }, params.frequency);

            case 11:
              response = _context3.sent;


              // Only update if this request is still the current one (i.e. not cancelled)
              if (currentCanceller === _this.requestCanceller) {
                _this.paymentRequestParams.amount = response.data.charge_summary.total_charge;
              }
              _context3.next = 18;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3['catch'](8);

              // Don't update amount if request was cancelled
              if (_context3.t0 !== 'cancelled') {
                // eslint-disable-next-line no-console
                console.error('*** Fee estimation failed:', _context3.t0);
              }

            case 18:

              if (params.frequency) {
                frequency = toTitleCase(params.frequency.replace('-', ' '));

                _this.paymentRequestParams.label = frequency + ' Donation';
                _this.paymentRequestParams.currency = params.currency.toLowerCase();
              }

              // Clear the canceller after successful completion, if this was the most recent request
              if (currentCanceller === _this.requestCanceller && !currentCanceller.promise.$$state.value) {
                _this.requestCanceller = null;
              }

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[8, 15]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.addShowDigitalWalletsListener = function (listener) {
    _this.showDigitalWalletsListeners.push(listener);
  };

  this.showDigitalWallets = function (show) {
    _this.showDigitalWalletsListeners.forEach(function (listener) {
      listener(show);
    });
  };

  this.addOnOpenDigitalWalletModalListener = function (listener) {
    _this.onOpenDigitalWalletModalListeners.push(listener);
  };

  this.openDigitalWalletModal = function () {
    _this.onOpenDigitalWalletModalListeners.forEach(function (listener) {
      listener();
    });
  };

  this.openDWModal = function () {
    _this.openDigitalWalletModal();
    scStripeService.paymentRequest.show();
  };

  this.addOnDigitalWalletsSubmitListener = function (listener) {
    _this.onDigitalWalletsSubmitListeners.push(listener);
  };

  this.onDigitalWalletsSubmit = function () {
    _this.setIsDigitalWalletsSubmission(true);
    _this.onDigitalWalletsSubmitListeners.forEach(function (listener) {
      listener();
    });
  };

  this.setIsDigitalWalletsSubmission = function (isDigitalWalletSubmission) {
    _this.isDigitalWalletSubmission = isDigitalWalletSubmission;
  };

  this.setIsLoaded = function (isLoaded) {
    _this.isLoaded = isLoaded;
  };

  var toTitleCase = function toTitleCase(string) {
    return string.toLowerCase().split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  };
}

angular.module('classy').service('scDigitalWalletsService', scDigitalWalletsService);
})();